var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95742 17.9585C9.54076 18.4501 10.4824 18.4501 11.0491 17.9585L12.3658 16.8335C12.6158 16.6251 13.0908 16.4501 13.4241 16.4501H14.8408C15.7241 16.4501 16.4491 15.7251 16.4491 14.8418V13.4251C16.4491 13.0918 16.6241 12.6251 16.8324 12.3751L17.9574 11.0585C18.4491 10.4751 18.4491 9.53346 17.9574 8.96679L16.8324 7.65013C16.6241 7.40013 16.4491 6.93346 16.4491 6.60013V5.18346C16.4491 4.30013 15.7241 3.57513 14.8408 3.57513H13.4241C13.0908 3.57513 12.6241 3.40013 12.3741 3.19179L11.0574 2.06679C10.4741 1.57513 9.53242 1.57513 8.96576 2.06679L7.64909 3.19179C7.39909 3.40013 6.92409 3.57513 6.59909 3.57513H5.14076C4.25742 3.57513 3.53242 4.30013 3.53242 5.18346V6.60846C3.53242 6.93346 3.36576 7.40846 3.15742 7.65013L2.03242 8.97513C1.54909 9.55013 1.54909 10.4835 2.03242 11.0585L3.15742 12.3835C3.36576 12.6335 3.53242 13.1001 3.53242 13.4251V14.8335C3.53242 15.7168 4.25742 16.4418 5.14076 16.4418H6.58242C6.91576 16.4418 7.38242 16.6168 7.63242 16.8251L8.95742 17.9585Z",
    stroke: "#564ECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.2251V9.2001",
    stroke: "#564ECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99674 6.66669H10.0042",
    stroke: "#564ECE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.b91b4bb29f8c59f4354f29dd9f862bdf.svg";
export { ForwardRef as ReactComponent };